// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Pagination, Autoplay, Navigation } from 'swiper/modules';
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import schedule from "../data/schedule.json";
// import "flag-icons/css/flag-icons.min.css";
// import React, { useRef } from "react";


// export default function Agenda() {
//     const swiperRef = useRef(null);
//     return (
//         <section className="schedule">
//             <div className="schedule-header">
//                 <h2>Programa <span>ConMujeres 2025</span></h2>
//             </div>

//             <div className="schedule-container">
//                 {schedule.map((block) => (
//                     <div key={block.id} className="schedule-block">
//                         <div className="schedule-left">
//                             <h3 className="font-bold text-xl">{block.name}</h3>
//                             <div className="time-range">
//                                 <p className="text-sm">{block.start}</p>
//                                 <span>–</span>
//                                 <p className="text-sm">{block.end}</p>
//                             </div>
//                         </div>
//                         <div className="timeline">
//                             <div className="timeline-item">
//                                 <span className="dot"></span>
//                             </div>
//                         </div>
//                         <div className="schedule-right">
//                             <h3 className="italic font-semibold mb-3">{block.title}</h3>


//                             <div className="ponentes-row">
//                                 <h2 className="ponentes-title">Ponentes</h2>

//                                 <div className="speakers-carousel-wrap">
//                                     <Swiper
//                                         modules={[Pagination, Autoplay, Navigation]}
//                                         slidesPerView={1}
//                                         spaceBetween={20}
//                                         autoplay={{ delay: 4000, disableOnInteraction: false }}
//                                         loop={true}
//                                         centeredSlides={true}
//                                         navigation={true}
//                                         pagination={{ clickable: true }}
//                                         className="speakers-carousel"
//                                     >

//                                         {block.speakers.map((sp, idx) => (
//                                             <SwiperSlide key={idx} className="speakers-slide !w-full">
//                                                 <div className="speaker-card">
//                                                     <div className="speaker-img">
//                                                         <img
//                                                             src={sp.image}
//                                                             alt={sp.name}
//                                                         />
//                                                         {sp.flag && (
//                                                             <span
//                                                                 className={`fi fi-${sp.flag} fis absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 text-xl`}
//                                                             ></span>
//                                                         )}
//                                                     </div>
//                                                     <div className='speaker-info'>
//                                                         <h5 className="speaker-name">
//                                                             {sp.name}
//                                                         </h5>
//                                                         <p className="speaker-role">{sp.role}</p>
//                                                     </div>
//                                                 </div>
//                                             </SwiperSlide>
//                                         ))}
//                                     </Swiper>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 ))}
//                 <div className="schedule-block">
//                     <div className="schedule-left">
//                         <h3 className="font-bold text-xl">Cierre</h3>
//                         <div className="time-range">
//                             <p className="text-sm">18:30 h</p>
//                             <p className="text-sm">19:00 h</p>
//                         </div>
//                     </div>

//                     <div className="timeline">
//                         <div className="timeline-item">
//                             <span className="dot"></span>
//                         </div>
//                     </div>

//                     <div className="schedule-right">
//                         <h3 className="italic font-semibold mb-3">Cierre / Premiación y Otros / Fotos / Coctel y After Coctel</h3>
//                         <div className="ponentes-row">
//                             <div className="speaker-card">
//                                 <div className="speaker-closure">
//                                     <img
//                                         src="/images/conmu4.jpg"
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// }
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import schedule from "../data/schedule.json";
import "flag-icons/css/flag-icons.min.css";
import React, { useRef } from "react";

export default function Agenda() {
    const swiperRef = useRef(null);

    return (
        <section className="schedule">
            <div className="schedule-header">
                <h2>Programa <span>ConMujeres 2025</span></h2>
            </div>

            <div className="schedule-container">
                {schedule.map((block) => {
                    const slidesCount = block.speakers?.length ?? 0;
                    const shouldLoop = slidesCount > 1;

                    return (
                        <div key={block.id} className="schedule-block">
                            <div className="schedule-left">
                                <h3 className="font-bold text-xl">{block.name}</h3>
                                <div className="time-range">
                                    <p className="text-sm">{block.start}</p>
                                    <span>–</span>
                                    <p className="text-sm">{block.end}</p>
                                </div>
                            </div>

                            <div className="timeline">
                                <div className="timeline-item">
                                    <span className="dot"></span>
                                </div>
                            </div>

                            <div className="schedule-right">
                                <h3 className="italic font-semibold mb-3">{block.title}</h3>

                                <div className="ponentes-row">
                                    <h2 className="ponentes-title">Ponentes</h2>

                                    <div className="speakers-carousel-wrap">
                                        <Swiper
                                            modules={[Pagination, Navigation, Autoplay]}
                                            slidesPerView={1}
                                            spaceBetween={10}               
                                            autoplay={shouldLoop ? { delay: 4000, disableOnInteraction: false } : false}
                                            loop={shouldLoop}
                                            centeredSlides={false}
                                            navigation={shouldLoop}
                                            pagination={slidesCount > 1 ? { clickable: true } : false}
                                            observer={true}                 
                                            observeParents={true}
                                            resizeObserver={true}
                                            onSwiper={(s) => (swiperRef.current = s)}
                                            className="speakers-carousel"
                                        >
                                            {block.speakers && block.speakers.length > 0 ? (
                                                block.speakers.map((sp, idx) => (
                                                    <SwiperSlide key={idx} className="speakers-slide">
                                                        <div className="speaker-card">
                                                            <div className="speaker-img">
                                                                <img src={sp.image} alt={sp.name} />
                                                            </div>
                                                            <div className="speaker-info">
                                                                <h5 className="speaker-name">{sp.name}</h5>
                                                                <p className="speaker-role">{sp.role}</p>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                ))
                                            ) : (
                                                <SwiperSlide>
                                                    <div className="speaker-card">
                                                        <div className="speaker-closure">
                                                            <img src="/images/conmu4.jpg" alt="Cierre" />
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            )}
                                        </Swiper>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}

                {/* bloque de cierre */}
                <div className="schedule-block">
                    <div className="schedule-left">
                        <h3 className="font-bold text-xl">Cierre</h3>
                        <div className="time-range">
                            <p className="text-sm">18:30 h</p>
                            <p className="text-sm">19:00 h</p>
                        </div>
                    </div>

                    <div className="timeline">
                        <div className="timeline-item">
                            <span className="dot"></span>
                        </div>
                    </div>

                    <div className="schedule-right">
                        <h3 className="italic font-semibold mb-3">Cierre / Premiación y Otros / Fotos / Coctel y After Coctel</h3>
                        <div className="ponentes-row">
                            <div className="speaker-card">
                                <div className="speaker-closure">
                                    <img src="/images/conmu4.jpg" alt="Cierre" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
}
